const fakeData =
  ({
    prefix,
    text = 'Aimetis',
    to = {
      name: 'brand-item',
      params: {
        brandAlias: 'cisco'
      }
    },
    length = 16
  }) => {
    const data = (dataText = text, dataTo = to) => {
      // return { text: `${dataText}${prefix}`, to: dataTo }
      return { text: dataText, to: dataTo }
    };

    return Array.from({ length: length })
      .fill(data());
  };

export const BRAND = [
  {
    text: 'Aimetis',
    alias: 'Aimetis'
  },
  {
    text: 'BlcakBerry',
    alias: 'BlcakBerry'
  },
  {
    text: 'CISCO',
    alias: 'CISCO'
  },
  {
    text: 'CyCraft奧義智慧科技',
    alias: 'CyCraft奧義智慧科技'
  },
  {
    text: 'F5',
    alias: 'F5'
  },
  {
    text: 'FireEye',
    alias: 'FireEye'
  },
  {
    text: 'FireMon',
    alias: 'FireMon'
  },
  {
    text: 'Forescout',
    alias: 'Forescout'
  },
  {
    text: 'Keysight Technologies',
    alias: 'Keysight Technologies'
  },
  {
    text: 'Lucent Sky',
    alias: 'Lucent Sky'
  },
  {
    text: 'NetApp',
    alias: 'NetApp'
  },
  {
    text: 'OPSWAT',
    alias: 'OPSWAT'
  },
  {
    text: 'Palo Alto Networks',
    alias: 'Palo Alto Networks'
  },
  {
    text: 'Progress',
    alias: 'Progress'
  },
  {
    text: 'Quest',
    alias: 'Quest'
  },
  {
    text: 'Thales',
    alias: 'Thales'
  },
  {
    text: 'Trend Micro',
    alias: 'Trend Micro'
  },
  {
    text: 'TrustView',
    alias: 'TrustView'
  },
  {
    text: 'Veritas',
    alias: 'Veritas'
  },
  {
    text: 'VMware',
    alias: 'VMware'
  },
];

export const SOLUTION_CLASS = [
  {
    text: '公共行政與國防',
    alias: '公共行政與國防'
  },
  {
    text: '其他服務業',
    alias: '其他服務業'
  },
  {
    text: '資訊及通訊業',
    alias: '資訊及通訊業'
  },
  {
    text: '網路視訊會議系統',
    alias: '網路視訊會議系統'
  },
  {
    text: '教育業',
    alias: '教育業'
  },
  {
    text: '其他',
    alias: '其他'
  }
];

export const BRAND_MENU = [
  {
    text: 'IT管理及效能監控',
    to: {
      name: 'brand-category',
      params: {
        categoryAlias: 'IT管理及效能監控'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'a', text: item.text, length: 1 })[0]
        }
      })
    }
  },
  {
    text: '資訊安全',
    to: {
      name: 'brand-category',
      params: {
        categoryAlias: '資訊安全'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'b', text: item.text, length: 1 })[0]
        }
      })
    }
  },
  {
    text: '基礎架構網路',
    to: {
      name: 'brand-category',
      params: {
        categoryAlias: '基礎架構網路'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'c', text: item.text, length: 1 })[0]
        }
      })
    }
  },
  {
    text: '儲存系統',
    to: {
      name: 'brand-category',
      params: {
        categoryAlias: '儲存系統'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'd', text: item.text, length: 1 })[0]
        }
      })
    }
  },
  {
    text: '備份備援',
    to: {
      name: 'brand-category',
      params: {
        categoryAlias: '備份備援'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'e', text: item.text, length: 1 })[0]
        }
      })
    }
  },
  {
    text: '虛擬化',
    to: {
      name: 'brand-category',
      params: {
        categoryAlias: '虛擬化'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'f', text: item.text, length: 1 })[0]
        }
      })
    }
  },
  {
    text: '視訊監控',
    to: {
      name: 'brand-category',
      params: {
        categoryAlias: '視訊監控'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'g', text: item.text, length: 1 })[0]
        }
      })
    }
  },
  {
    text: '雲端服務',
    to: {
      name: 'brand-category',
      params: {
        categoryAlias: '雲端服務'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'g', text: item.text, length: 1 })[0]
        }
      })
    }
  },
  {
    text: 'AI 大數據',
    to: {
      name: 'brand-category',
      params: {
        categoryAlias: 'AI 大數據'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'g', text: item.text, length: 1 })[0]
        }
      })
    }
  },
  {
    text: '容器及DevOps',
    to: {
      name: 'brand-category',
      params: {
        categoryAlias: '容器及DevOps'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'g', text: item.text, length: 1 })[0]
        }
      })
    }
  },
  {
    text: '遠距應用',
    to: {
      name: 'brand-category',
      params: {
        categoryAlias: '遠距應用'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'g', text: item.text, length: 1 })[0]
        }
      })
    }
  },
  {
    text: '超融合基礎架構',
    to: {
      name: 'brand-category',
      params: {
        categoryAlias: '超融合基礎架構'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'g', text: item.text, length: 1 })[0]
        }
      })
    }
  },
  {
    text: '商業應用軟體',
    to: {
      name: 'brand-category',
      params: {
        categoryAlias: '商業應用軟體'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'g', text: item.text, length: 1 })[0]
        }
      })
    }
  },
];

export const SOLUTION_MENU = [
  {
    text: 'IT管理及效能監控',
    icon: 'icon1',
    to: {
      name: 'solution-list',
      query: {
        filterCategory: 'IT管理及效能監控'
      }
    },
    data: {
      items: SOLUTION_CLASS.map((item, index) => {
        return {
          ...fakeData({
            prefix: 'a',
            text: item.text,
            length: 1,
            to: {
              name: 'solution-list',
              query: {
                filterCategory: 'IT管理及效能監控',
                filterClass: item.text
              }
            }
          })[0]
        }
      }),
      description: '為企業提供全面整合真正的自動化安全基礎架構，無論是虛擬環境、雲端環境還是從事內部部署，為每個網路區段、設備、設備與設備間提供 無與倫比的保護和可視性。'
    }
  },
  {
    text: '資訊安全',
    icon: 'icon2',
    to: {
      name: 'solution-list',
      query: {
        filterCategory: '資訊安全'
      }
    },
    data: {
      items: SOLUTION_CLASS.map((item, index) => {
        return {
          ...fakeData({
            prefix: 'b',
            text: item.text,
            length: 1,
            to: {
              name: 'solution-list',
              query: {
                filterCategory: '資訊安全',
                filterClass: item.text
              }
            }
          })[0]
        }
      }),
      description: '網路暨資訊安全為企業提供全面整合真正的自動化安全基礎架構，無論是虛擬環境、雲端環境還是從事內部部署，為每個網路區段、設備、設備與設備間提供 無與倫比的保護和可視性。'
    },
  },
  {
    text: '基礎架構網路',
    icon: 'icon3',
    to: {
      name: 'solution-list',
      query: {
        filterCategory: '基礎架構網路'
      }
    },
    data: {
      items: SOLUTION_CLASS.map((item, index) => {
        return {
          ...fakeData({
            prefix: 'c',
            text: item.text,
            length: 1,
            to: {
              name: 'solution-list',
              query: {
                filterCategory: '基礎架構網路',
                filterClass: item.text
              }
            }
          })[0]
        }
      }),
      description: '雲平台與應用為企業提供全面整合真正的自動化安全基礎架構，無論是虛擬環境、雲端環境還是從事內部部署，為每個網路區段、設備、設備與設備間提供 無與倫比的保護和可視性。'
    },
  },
  {
    text: '儲存系統',
    icon: 'icon4',
    to: {
      name: 'solution-list',
      query: {
        filterCategory: '儲存系統'
      }
    },
    data: {
      items: SOLUTION_CLASS.map((item, index) => {
        return {
          ...fakeData({
            prefix: 'd',
            text: item.text,
            length: 1,
            to: {
              name: 'solution-list',
              query: {
                filterCategory: '儲存系統',
                filterClass: item.text
              }
            }
          })[0]
        }
      }),
      description: '大數據與應用為企業提供全面整合真正的自動化安全基礎架構，無論是虛擬環境、雲端環境還是從事內部部署，為每個網路區段、設備、設備與設備間提供 無與倫比的保護和可視性。'
    },
  },
  {
    text: '備份備援',
    icon: 'icon5',
    to: {
      name: 'solution-list',
      query: {
        filterCategory: '備份備援'
      }
    },
    data: {
      items: SOLUTION_CLASS.map((item, index) => {
        return {
          ...fakeData({
            prefix: 'e',
            text: item.text,
            length: 1,
            to: {
              name: 'solution-list',
              query: {
                filterCategory: '備份備援',
                filterClass: item.text
              }
            }
          })[0]
        }
      }),
      description: '資料安全防護為企業提供全面整合真正的自動化安全基礎架構，無論是虛擬環境、雲端環境還是從事內部部署，為每個網路區段、設備、設備與設備間提供 無與倫比的保護和可視性。'
    },
  },
  {
    text: '虛擬化',
    icon: 'icon6',
    to: {
      name: 'solution-list',
      query: {
        filterCategory: '虛擬化'
      }
    },
    data: {
      items: SOLUTION_CLASS.map((item, index) => {
        return {
          ...fakeData({
            prefix: 'f',
            text: item.text,
            length: 1,
            to: {
              name: 'solution-list',
              query: {
                filterCategory: '虛擬化',
                filterClass: item.text
              }
            }
          })[0]
        }
      }),
      description: '資安事件管理為企業提供全面整合真正的自動化安全基礎架構，無論是虛擬環境、雲端環境還是從事內部部署，為每個網路區段、設備、設備與設備間提供 無與倫比的保護和可視性。'
    },
  },
  {
    text: '視訊監控',
    icon: 'icon7',
    to: {
      name: 'solution-list',
      query: {
        filterCategory: '視訊監控'
      }
    },
    data: {
      items: SOLUTION_CLASS.map((item, index) => {
        return {
          ...fakeData({
            prefix: 'g',
            text: item.text,
            length: 1,
            to: {
              name: 'solution-list',
              query: {
                filterCategory: '視訊監控',
                filterClass: item.text
              }
            }
          })[0]
        }
      }),
      description: 'MetaDefender Core為企業提供全面整合真正的自動化安全基礎架構，無論是虛擬環境、雲端環境還是從事內部部署，為每個網路區段、設備、設備與設備間提供 無與倫比的保護和可視性。'
    },
  },
  {
    text: '雲端服務',
    icon: 'icon8',
    to: {
      name: 'solution-list',
      query: {
        filterCategory: '雲端服務'
      }
    },
    data: {
      items: SOLUTION_CLASS.map((item, index) => {
        return {
          ...fakeData({
            prefix: 'a',
            text: item.text,
            length: 1,
            to: {
              name: 'solution-list',
              query: {
                filterCategory: '雲端服務',
                filterClass: item.text
              }
            }
          })[0]
        }
      }),
      description: '為企業提供全面整合真正的自動化安全基礎架構，無論是虛擬環境、雲端環境還是從事內部部署，為每個網路區段、設備、設備與設備間提供 無與倫比的保護和可視性。'
    }
  },
  {
    text: 'AI 大數據',
    icon: 'icon9',
    to: {
      name: 'solution-list',
      query: {
        filterCategory: 'AI 大數據'
      }
    },
    data: {
      items: SOLUTION_CLASS.map((item, index) => {
        return {
          ...fakeData({
            prefix: 'b',
            text: item.text,
            length: 1,
            to: {
              name: 'solution-list',
              query: {
                filterCategory: 'AI 大數據',
                filterClass: item.text
              }
            }
          })[0]
        }
      }),
      description: '網路暨資訊安全為企業提供全面整合真正的自動化安全基礎架構，無論是虛擬環境、雲端環境還是從事內部部署，為每個網路區段、設備、設備與設備間提供 無與倫比的保護和可視性。'
    },
  },
  {
    text: '容器及DevOps',
    icon: 'icon10',
    to: {
      name: 'solution-list',
      query: {
        filterCategory: '容器及DevOps'
      }
    },
    data: {
      items: SOLUTION_CLASS.map((item, index) => {
        return {
          ...fakeData({
            prefix: 'c',
            text: item.text,
            length: 1,
            to: {
              name: 'solution-list',
              query: {
                filterCategory: '容器及DevOps',
                filterClass: item.text
              }
            }
          })[0]
        }
      }),
      description: '雲平台與應用為企業提供全面整合真正的自動化安全基礎架構，無論是虛擬環境、雲端環境還是從事內部部署，為每個網路區段、設備、設備與設備間提供 無與倫比的保護和可視性。'
    },
  },
  {
    text: '遠距應用',
    icon: 'icon11',
    to: {
      name: 'solution-list',
      query: {
        filterCategory: '遠距應用'
      }
    },
    data: {
      items: SOLUTION_CLASS.map((item, index) => {
        return {
          ...fakeData({
            prefix: 'd',
            text: item.text,
            length: 1,
            to: {
              name: 'solution-list',
              query: {
                filterCategory: '遠距應用',
                filterClass: item.text
              }
            }
          })[0]
        }
      }),
      description: '大數據與應用為企業提供全面整合真正的自動化安全基礎架構，無論是虛擬環境、雲端環境還是從事內部部署，為每個網路區段、設備、設備與設備間提供 無與倫比的保護和可視性。'
    },
  },
  {
    text: '超融合基礎架構',
    icon: 'icon12',
    to: {
      name: 'solution-list',
      query: {
        filterCategory: '超融合基礎架構'
      }
    },
    data: {
      items: SOLUTION_CLASS.map((item, index) => {
        return {
          ...fakeData({
            prefix: 'e',
            text: item.text,
            length: 1,
            to: {
              name: 'solution-list',
              query: {
                filterCategory: '超融合基礎架構',
                filterClass: item.text
              }
            }
          })[0]
        }
      }),
      description: '資料安全防護為企業提供全面整合真正的自動化安全基礎架構，無論是虛擬環境、雲端環境還是從事內部部署，為每個網路區段、設備、設備與設備間提供 無與倫比的保護和可視性。'
    },
  },
  {
    text: '商業應用軟體',
    icon: 'icon13',
    to: {
      name: 'solution-list',
      query: {
        filterCategory: '商業應用軟體'
      }
    },
    data: {
      items: SOLUTION_CLASS.map((item, index) => {
        return {
          ...fakeData({
            prefix: 'e',
            text: item.text,
            length: 1,
            to: {
              name: 'solution-list',
              query: {
                filterCategory: '商業應用軟體',
                filterClass: item.text
              }
            }
          })[0]
        }
      }),
      description: '資料安全防護為企業提供全面整合真正的自動化安全基礎架構，無論是虛擬環境、雲端環境還是從事內部部署，為每個網路區段、設備、設備與設備間提供 無與倫比的保護和可視性。'
    },
  },
  {
    text: '顧問服務',
    icon: 'icon14',
    to: {
      name: 'solution-list',
      query: {
        filterCategory: '顧問服務'
      }
    },
    data: {
      items: SOLUTION_CLASS.map((item, index) => {
        return {
          ...fakeData({
            prefix: 'e',
            text: item.text,
            length: 1,
            to: {
              name: 'solution-list',
              query: {
                filterCategory: '顧問服務',
                filterClass: item.text
              }
            }
          })[0]
        }
      }),
      description: '顧問服務無論是虛擬環境、雲端環境還是從事內部部署，為每個網路區段、設備、設備與設備間提供 無與倫比的保護和可視性。'
    },
  },
];

export const PRODUCT_MENU = [
  {
    text: 'IT基礎架構',
    to: {
      name: 'product-list',
      query: {
        filterCategory: 'IT基礎架構'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'a', text: item.text, length: 1 })[0]
        }
      })
    }
  },
  {
    text: '網路暨資訊安全',
    to: {
      name: 'product-list',
      query: {
        filterCategory: '網路暨資訊安全'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'b', text: item.text, length: 1 })[0]
        }
      })
    }
  },
  {
    text: '雲平台與應用',
    to: {
      name: 'product-list',
      query: {
        filterCategory: '雲平台與應用'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'c', text: item.text, length: 1 })[0]
        }
      })
    }
  },
  {
    text: '大數據與應用',
    to: {
      name: 'product-list',
      query: {
        filterCategory: '大數據與應用'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'd', text: item.text, length: 1 })[0]
        }
      })
    }
  },
  {
    text: '供契投標採購',
    to: {
      name: 'product-list',
      query: {
        filterCategory: '供契投標採購'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'e', text: item.text, length: 1 })[0]
        }
      })
    }
  },
  {
    text: '雲端服務網',
    to: {
      name: 'product-list',
      query: {
        filterCategory: '雲端服務網'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'f', text: item.text, length: 1 })[0]
        }
      })
    }
  },
  {
    text: 'ZOiPS數位監控',
    to: {
      name: 'product-list',
      query: {
        filterCategory: 'ZOiPS數位監控'
      }
    },
    data: {
      items: BRAND.map((item, index) => {
        return {
          ...fakeData({ prefix: 'g', text: item.text, length: 1 })[0]
        }
      })
    }
  }
];

export const SOLUTION_CATEGORY = [
  {
    text: 'IT基礎架構',
    alias: 'IT基礎架構'
  },
  {
    text: '網路資訊安全',
    alias: '網路資訊安全'
  },
  {
    text: '雲平台與應用',
    alias: '雲平台與應用'
  },
  {
    text: '大數據與應用',
    alias: '大數據與應用'
  },
  {
    text: '資料安全防護',
    alias: '資料安全防護'
  },
  {
    text: '資安事件管理',
    alias: '資安事件管理',
  },
  {
    text: 'MetaDefender Core',
    alias: 'MetaDefender Core',
  },
];


export const PRODUCT_CATEGORY = [
  {
    text: 'IT基礎架構',
    alias: 'IT基礎架構'
  },
  {
    text: '網路暨資訊安全',
    alias: '網路暨資訊安全'
  },
  {
    text: '雲平台與應用',
    alias: '雲平台與應用'
  },
  {
    text: '大數據與應用',
    alias: '大數據與應用'
  },
  {
    text: '供契投標採購',
    alias: '供契投標採購'
  },
  {
    text: '雲端服務網',
    alias: '雲端服務網'
  },
  {
    text: 'ZOiPS數位監控',
    alias: 'ZOiPS數位監控'
  }
];

export const KEYWORD = [
  {
    text: '經銷商限定',
  },
  {
    text: '自動化',
  },
  {
    text: '安全基礎架構',
  },
  {
    text: '經銷限定',
  },
];

const aboutText = `
  <p> 2017零壹科技Solution Day (台中場) 次世代AI雲平台與大數據資安防禦應用，你該知道的新趨勢 </p>
  <p>
    自從Google
    AlphaGo在圍棋上陸續戰勝世界棋王李世乭與柯潔後，AI人工智慧成為全世界關注的關鍵技術，更激發各種新興應用及新商業模式，進而讓人類未來生活與工作帶來各種想像，同時也為各行各業創造新的商機與挑戰。
  </p>
  <p>
    近年來由於雲端科技發展日益成熟，促使了多元化的應用服務隨之崛起，藉此驅動了科技創新及數位轉型。其中：AI人工智慧、雲端平台整合與大數據分析，是企業必須首要掌握的新趨勢。除此之外，資安防護更是企業在追求新趨勢之際，不能被忽略的重要一環。
  </p>
  <p>
    為了讓企業能掌握新趨勢，以因應未來的布局，此次2017零壹科技Solution
    Day台中場，我們將告訴您AI人工智慧如何正以驚人的速度發展；大數據分析藉由機器學習帶來更智能的預測；如何運用超融合軟硬整合，高效掌控數位資料；並帶領您因應未來資安的挑戰。
  </p>
`
const descriptionText = `   
  <p>本活動採預先報名，經主辦單位確認符合活動屬性即報名成功。完成報名後，您將在活動前一天收到出席提醒函，內容包含此次活動使用直播平台登入網址及活動注意事項。
     問卷禮將於活動統整完畢後寄出，將會使用email或手機號碼方式寄發，請務必填寫正確，事後將不予補發。<br />
     Email請務必填寫公司信箱，否則不列入予採計。 主辦單位保有活動內容修改之權益。
  </p>
`

const aboutTextMultiple = `
  <p>
    此為初階課程，配合實例解說案例，由淺入深講解 NetApp FAS / AFF 相關技術，利用實際操作的方式，印證理論和基礎的關聯性，協助參與此課程的 NetApp 使用者，能熟悉 NetApp FAS / AFF
    產品的基本操作。此為初階課程，配合實例解說案例。
  </p>
  <p> 
    由淺入深講解 NetApp FAS / AFF 相關技術，利用實際操作的方式，印證理論和基礎的關聯性，協助參與此課程的 NetApp 使用者，能熟悉 NetApp FAS / AFF 產品的基本操作。
  </p>
  <p>
    活動簡介測試文字活動簡介測試文字活動簡介測試文字活動簡介測試文字活動簡介測試文字 
  </p>
`

const schedule = [
  {
    content: '報到',
    timestamp: '13:00-13:30',
  },
  {
    content: '致歡迎詞',
    timestamp: '13:30-13:40',
  },
  {
    content: '劃時代產業革命-AI 人工智慧',
    timestamp: '13:40-14:20',
    teacher: {
      name: '楊博欽',
      description: 'NVIDIA 合作夥伴通路經理',
    },
  },
  {
    content: '以領導者角度闡釋現代雲平台',
    timestamp: '14:20-15:00',
    teacher: {
      name: '黃禹平',
      description: '零壹科技產品經理',
    },
  },
  {
    content: '茶點交誼',
    timestamp: '15:00-15:20',
  },
  {
    content: '透過機器學習來探索資料的價值',
    timestamp: '15:20-16:00',
    teacher: {
      name: '楊博欽',
      description: 'NVIDIA 合作夥伴通路經理',
    },
  },
  {
    content: '攻擊實境秀:你以為的安全網站,真的嗎??',
    timestamp: '16:00-16:40',
    teacher: {
      name: '黃禹平',
      description: '零壹科技產品經理',
    },
  },

  {
    content: '幸運抽獎. 下次見',
    timestamp: '16:40',
  }
];

const courseSession = {
  time: '11:00 - 13:00',
  title: '場次標題測試文字測試文字測試文字測試文字測試文字',
  aboutText: aboutTextMultiple,
  descriptionText,
  logo: 'https://img-prod-cms-rt-microsoft-com.akamaized.net/cms/api/am/imageFileData/RE1Mu3b?ver=5c31',
  location: '零宇學苑602教室(台北市內湖區瑞光路513巷35號6樓)',
  contact: '02-26565770 魏小姐',
  schedule
};

const courseSessionIsLive = { ...courseSession, live: '相關Youtube播放網址將在通過報名後查看' }

const single = {
  pageType: 'single',
  pageTypeAlias: '單一場',
  title: '零壹科技企業解決方案日-單天單場',
  date: '2021/05/14',
  time: '2017/08/25(五) (13:00至16:40)',
  brand: 'cisco',
  brandLink: [
    {
      title: 'cisco',
      logo_image: 'https://img-prod-cms-rt-microsoft-com.akamaized.net/cms/api/am/imageFileData/RE1Mu3b?ver=5c31',
    }
  ],
  location: '林酒店6F仙侶廳(台中市西屯區朝富路99號)',
  state: '開放報名中',
  authority: '活動僅限指定廠商參與',
  aboutText,
  descriptionText,
  schedule,
  sponsor: ['logo-1',
    'logo-2',
    'logo-3',
    'logo-4',
    'logo-5',
    'logo-6',
    'logo-7',
    'logo-8',
    'logo-9'],
  isLive: false,
  isCoupon: true,
  to: {
    name: 'brand-event-item',
    params: {
      eventAlias: 'single',
      brandAlias: 'cisco',
      pageType: 'single'
    },
  },
}

const singleDone = {
  pageType: 'single',
  pageTypeAlias: '單一場',
  title: '零壹科技企業解決方案日-單天單場報名額滿',
  date: '2021/05/14',
  time: '2017/08/25(五) (13:00至16:40)',
  brand: 'cisco',
  brandLink: [
    {
      title: 'cisco',
      logo_image: 'https://img-prod-cms-rt-microsoft-com.akamaized.net/cms/api/am/imageFileData/RE1Mu3b?ver=5c31',
    }
  ],
  location: '林酒店6F仙侶廳(台中市西屯區朝富路99號)',
  state: '報名額滿',
  authority: '活動僅限指定廠商參與',
  aboutText,
  descriptionText,
  schedule,
  sponsor: ['logo-1',
    'logo-2',
    'logo-3',
    'logo-4',
    'logo-5',
    'logo-6',
    'logo-7',
    'logo-8',
    'logo-9'],
  isLive: false,
  isCoupon: true,
  to: {
    name: 'brand-event-item',
    params: {
      eventAlias: 'single',
      brandAlias: 'cisco',
      pageType: 'single',
      fakeState: '報名額滿',
    },
  },
}

const multipleItems = {
  pageType: 'multiple-items',
  pageTypeAlias: '單天多場',
  title: '零壹科技企業解決方案日-單天多場',
  date: '2021/05/14',
  time: '2017/08/25(五) (13:00至16:40)',
  logo: 'https://img-prod-cms-rt-microsoft-com.akamaized.net/cms/api/am/imageFileData/RE1Mu3b?ver=5c31',
  brandLink: [
    {
      title: 'cisco',
      logo_image: 'https://img-prod-cms-rt-microsoft-com.akamaized.net/cms/api/am/imageFileData/RE1Mu3b?ver=5c31',
    }
  ],
  state: '開放報名中',
  authority: '活動僅限指定廠商參與',
  aboutTextMultiple,
  sponsor: ['logo-1',
    'logo-2',
    'logo-3',
    'logo-4',
    'logo-5',
    'logo-6',
    'logo-7',
    'logo-8',
    'logo-9',
    'logo-10',
    'logo-11',
    'logo-12'],
  isLive: false,
  isCoupon: true,
  items: Array.from({ length: 6 })
    .fill(courseSession),
  to: {
    name: 'brand-event-item',
    params: {
      eventAlias: 'multiple-items',
      brandAlias: 'cisco',
      pageType: 'multiple-items',
      fakeState: '開放報名中'
    },
  },
}
const multipleDayItems = {
  pageType: 'multiple-day-items',
  pageTypeAlias: '多天多場',
  title: '零壹科技企業解決方案日-多天多場',
  logo: 'https://img-prod-cms-rt-microsoft-com.akamaized.net/cms/api/am/imageFileData/RE1Mu3b?ver=5c31',
  date: '2021/05/14~2021/5/28',
  time: '2021/05/14~2021/5/28 (13:00至16:40)',
  brand: 'cisco',
  state: '開放報名中',
  authority: '活動僅限指定廠商參與',
  aboutTextMultiple,
  items: Array.from({ length: 6 })
    .fill(courseSession),
  sponsor: ['logo-1',
    'logo-2',
    'logo-3',
    'logo-4',
    'logo-5',
    'logo-6',
    'logo-7',
    'logo-8',
    'logo-9',
    'logo-10',
    'logo-11',
    'logo-12'],
  isLive: false,
  isCoupon: true,
  to: {
    name: 'brand-event-item',
    params: {
      eventAlias: 'multiple-day-items',
      brandAlias: 'cisco',
      pageType: 'multiple-day-items',
      fakeState: '開放報名中'
    },
  },
}

const singleIsLive = {
  pageType: 'single-isLive',
  pageTypeAlias: '單一場',
  title: '零壹科技企業解決方案日-單天單場',
  date: '2021/05/14',
  time: '2017/08/25(五) (13:00至16:40)',
  brand: 'cisco',
  brandLink: [
    {
      title: 'cisco',
      logo_image: 'https://img-prod-cms-rt-microsoft-com.akamaized.net/cms/api/am/imageFileData/RE1Mu3b?ver=5c31',
    }
  ],
  location: '林酒店6F仙侶廳(台中市西屯區朝富路99號)',
  state: '開放報名中',
  authority: '活動僅限指定廠商參與',
  aboutText,
  descriptionText,
  schedule,
  sponsor: ['logo-1',
    'logo-2',
    'logo-3',
    'logo-4',
    'logo-5',
    'logo-6',
    'logo-7',
    'logo-8',
    'logo-9'],
  isLive: true,
  isCoupon: false,
  items: [courseSessionIsLive],
  to: {
    name: 'brand-event-item',
    params: {
      eventAlias: 'single-isLive',
      brandAlias: 'cisco',
      pageType: 'single-isLive',
      fakeState: '開放報名中'
    },
  },
}

const multipleItemsIsLive = {
  pageType: 'multiple-items-isLive',
  pageTypeAlias: '單天多場',
  title: '零壹科技企業解決方案日-單天多場',
  date: '2021/05/14',
  time: '2017/08/25(五) (13:00至16:40)',
  brand: 'cisco',
  state: '開放報名中',
  authority: '活動僅限指定廠商參與',
  aboutTextMultiple,
  sponsor: ['logo-1',
    'logo-2',
    'logo-3',
    'logo-4',
    'logo-5',
    'logo-6',
    'logo-7',
    'logo-8',
    'logo-9',
    'logo-10',
    'logo-11',
    'logo-12'],
  isLive: true,
  items: Array.from({ length: 6 })
    .fill(courseSessionIsLive),
  to: {
    name: 'brand-event-item',
    params: {
      eventAlias: 'multiple-items-isLive',
      brandAlias: 'cisco',
      pageType: 'multiple-items-isLive',
      fakeState: '開放報名中'
    },
  },
}

const singleIsLiving = {
  pageType: 'single-isLive',
  pageTypeAlias: '單一場',
  title: '零壹科技企業解決方案日-單天單場',
  date: '2021/05/14',
  time: '2017/08/25(五) (13:00至16:40)',
  brand: 'cisco',
  brandLink: [
    {
      title: 'cisco',
      logo_image: 'https://img-prod-cms-rt-microsoft-com.akamaized.net/cms/api/am/imageFileData/RE1Mu3b?ver=5c31',
    }
  ],
  location: '林酒店6F仙侶廳(台中市西屯區朝富路99號)',
  state: '活動中',
  authority: '活動僅限指定廠商參與',
  aboutText,
  descriptionText,
  schedule,
  sponsor: ['logo-1',
    'logo-2',
    'logo-3',
    'logo-4',
    'logo-5',
    'logo-6',
    'logo-7',
    'logo-8',
    'logo-9'],
  isLive: true,
  isCoupon: false,
  items: [courseSessionIsLive],
  to: {
    name: 'brand-event-item',
    params: {
      eventAlias: 'single-isLive',
      brandAlias: 'cisco',
      pageType: 'single-isLive',
      fakeState: '活動中'
    },
  },
}

const multipleDayItemsDone = {
  pageType: 'multiple-day-items',
  pageTypeAlias: '多天多場',
  title: '零壹科技企業解決方案日-多天多場',
  logo: 'https://img-prod-cms-rt-microsoft-com.akamaized.net/cms/api/am/imageFileData/RE1Mu3b?ver=5c31',
  date: '2021/05/14~2021/5/28',
  time: '2021/05/14~2021/5/28 (13:00至16:40)',
  brand: 'cisco',
  state: '報名截止',
  authority: '活動僅限指定廠商參與',
  aboutTextMultiple,
  items: Array.from({ length: 6 })
    .fill(courseSession),
  sponsor: ['logo-1',
    'logo-2',
    'logo-3',
    'logo-4',
    'logo-5',
    'logo-6',
    'logo-7',
    'logo-8',
    'logo-9',
    'logo-10',
    'logo-11',
    'logo-12'],
  isLive: false,
  isCoupon: true,
  to: {
    name: 'brand-event-item',
    params: {
      eventAlias: 'multiple-day-items',
      brandAlias: 'cisco',
      pageType: 'multiple-day-items',
      fakeState: '報名截止'
    },
  },
}


const courseGroup = [
  single,
  multipleItems,
  multipleDayItems,
  singleIsLive,
  multipleItemsIsLive,
  singleDone,
  multipleDayItemsDone,
  singleIsLiving
]

export const COURSE_LIST = {
  first: courseGroup,
  second: courseGroup
}
